import { useApi } from '@/api';
import { Page, PageSkeleton, WalletHeading } from '@/components';
import { useSearchParams } from '@/hooks';
import { useParams } from 'react-router';
import ActivityTable from './ActivityTable';
import HistoricTabs from './HistoricTabs';
import { DEFAULT_NETWORK } from '@/constants';

export type Wallet = {
  wallet_address: string;
  total_supply: string;
  total_supply_change: string | number;
  total_supply_change_percentage: string | number;
  total_borrow: string;
  total_borrow_change: string | number;
  total_borrow_change_percentage: string | number;
  net: string;
  liquidation_buffer: string;
  liquidation_buffer_change: string | number;
  liquidation_buffer_change_percentage: string | number;
  account_liquidity: string;
  account_liquidity_change: string | number;
  account_liquidity_change_percentage: string | number;
  health_rate: string;
  health_rate_change: string | number;
  health_rate_change_percentage: string | number;
  emode: number;
};

export default function WalletActivityPage() {
  const { walletAddress } = useParams() as {
    walletAddress: string;
  };
  const network = DEFAULT_NETWORK;
  const [date] = useSearchParams('date', '');
  const [data, error] = useApi<Wallet>({
    url: `/wallets/${walletAddress}/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <PageSkeleton />;
  }

  return (
    <Page>
      <WalletHeading
        walletAddress={walletAddress}
        totalSupply={data.total_supply}
        totalBorrow={data.total_borrow}
        healthRate={data.health_rate}
        network={network}
      />

      {!date ? <HistoricTabs /> : null}

      <ActivityTable
        walletAddress={walletAddress}
        network={network}
        forDate={date}
      />
    </Page>
  );
}
